/**
 * Module-level holder for the current OIDC access token.
 *
 * The RPC client middleware needs the token at fetch time to set the
 * `Authorization` header, but the middleware runs outside React so it can't
 * call `useAuth()`. Instead, `CurrentUserProvider` watches the OIDC user
 * manager and pushes the latest token here whenever it changes.
 *
 * Server-side this module is never written to — every `createServerFn` call
 * that touches it runs on the client, where the token is always available
 * from the OIDC user store. During SSR the module's value stays `null` and
 * the middleware sends an empty header; the server-side verifier then rejects
 * with 401, which is the correct behaviour for unauthenticated SSR loads.
 */

let currentAccessToken: string | null = null

export function setAccessToken(token: string | null): void {
  currentAccessToken = token
}

export function getAccessToken(): string | null {
  return currentAccessToken
}
